export default function Marquee({ items }) {
  const content = items.join("   ✦   ");
  return (
    <div className="marquee py-10 border-y border-[#C9A227]/20 bg-[#F3EADB]" data-testid="marquee">
      <div className="marquee-track whitespace-nowrap">
        <span className="font-bodoni text-3xl md:text-5xl tracking-tight text-[#A67C00]/90 px-12">
          {content}   ✦   {content}   ✦&nbsp;
        </span>
        <span className="font-bodoni text-3xl md:text-5xl tracking-tight text-[#A67C00]/90 px-12">
          {content}   ✦   {content}   ✦&nbsp;
        </span>
      </div>
    </div>
  );
}
